export default "__VITE_ASSET__iM4GFPuL__"